<template>
  <div class="management-navbar">
    <div class="user-container-div">

      <div class="minimize-button" :class="{ closed: !sidebarIsOpen }">
        <v-btn @click="toggleSidebar" icon>
          <v-icon color="#767676" v-if="!sidebarIsOpen">mdi-menu </v-icon>
          <v-icon color="#767676" v-else>mdi-menu-open </v-icon>
        </v-btn>
      </div>
      <div class="page-name" :class="{ closed: !sidebarIsOpen }">
        {{ pageName }}
      </div>
    </div>

    <div class="user-container-div" v-on-clickaway="closeWindow" id="badge">
      <div id="navbar-vertical-hr" />

      <v-badge
        :content="messages.length > 9 ? '9+' : messages.length"
        :value="messages.length"
        color="accent"
        tile
        bordered
        dark
        overlap
        class="ma-4"
      >
        <v-btn icon @click="onNotificationButtonClick">
          <v-icon color="#767676" size="25">notifications_none</v-icon>
        </v-btn>
      </v-badge>

      <user-button
        @click.native="onUserButtonClick"
        avatarWidth="35px"
        avatarHeight="35px"
        nameSize="12px"
        class="navbar-user-button"
        id="userButton"
      />
      <transition name="slide-fade">
        <notifications-window
          :right="width"
          top="28px"
          v-show="notificationWindow"
          :notificationOpen="notificationWindow"
          @notifications="setNotificationNumber"
        />
      </transition>

      <user-window right="15px" top="55px" v-show="userWindow" />
    </div>
    <activate-two-authentication-dialog
      :open="opened2FArequired"
      @close="opened2FArequired = false "
      @activateAuthenticate="twoFactorAuthentication = true"
    />
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mixin as clickaway } from "vue-clickaway";
import { twoFactorAuthenticationMixin } from "@/mixins/twoFactorAuthenticationMixin";
import ActivateTwoAuthenticationDialog from "@/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog";

import NotificationsSVG from "@/assets/management/notifications.svg";

import UserButton from "../User/Navbar/UserButton";
import UserWindow from "../User/Navbar/UserWindow/UserWindow";

export default {
  name: "NavBar",

  components: {

    NotificationsSVG,
    UserButton,
    UserWindow,
    ActivateTwoAuthenticationDialog
  },

  mixins: [clickaway, checkPermissionsMixin, twoFactorAuthenticationMixin],

  props: {
    /**
     * Determines if sidebar is open
     */
    sidebarIsOpen: Boolean,

    /**
     * Determines the title of the page
     */
    pageName: String
  },

  data() {
    return {
      /**
       * Determines if the user window is open
       */
      userWindow: false,
      /**
       * Store notification messages
       */
      messages: [],
      /**
       * Determines if the notification window is open
       */
      notificationWindow: false,

      /**
       * Determines position notification window
       */
      width: "0"
    };
  },

  mounted() {
    setTimeout(() => {
      this.companie2FArequired();
    }, 500)
  },

  methods: {
    /**
     * Close user window
     */
    closeWindow() {
      this.userWindow = false;
    },

    /**
     * Checks if the readAt is null, if so, the notifications get filtered to message data property to use with vuetify badge
     * @param {Array} data - Array of notifications
     */
    setNotificationNumber(data) {
      this.messages = data.filter(item => !item.readAt);
    },

    /**
     * Clicking the user button opens/closes the notification window and closes the user window
     */
    onNotificationButtonClick() {
      this.width = document.getElementById("userButton").clientWidth - 2 + "px";
      this.notificationWindow = !this.notificationWindow;
      this.userWindow = false;
    },

    /**
     * Clicking the user button opens/closes the user window and closes the notification window
     */
    onUserButtonClick() {
      this.userWindow = !this.userWindow;
      this.notificationWindow = false;
    },

    /**
     * Sends an event to the parent component to open/close the sidebar
     */
    toggleSidebar() {
      this.$emit("toggle-nav");
    }
  }
};
</script>

<style scoped>
.minimize-button {
  width: 40px;
  position: absolute;
  left: 250px;
}
.minimize-button.closed {
  left: 90px;
}
.page-name {
  margin-left: 305px;
  color: black;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.2px;
}

.page-name.closed {
  margin-left: 145px;
}

#management-fibercloudSVGlogo {
  padding: 8px 0 5px 15px;
  margin: 0;
}
.return-to-tooltip {
  color: var(--secondary-lighter);
  z-index: 100;
}

#badge >>> .v-badge__badge {
  color: black !important;
  font-weight: 600 !important;
  font-size: 13px;
  padding: 1px !important;
  min-width: 16px !important;
  height: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/NavBar.vue